import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/AccountCircle";
import { useLogout } from "../../auth/useLogout";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { styled } from "@mui/system";
import { useAuth } from "../../auth/useAuth";

const PersonOutlineIconStyled = styled(PersonOutlineIcon)`
  height: 21px;
  width: 21px;
  margin-right: 8px;
`;

const LogoutIconStyled = styled(LogoutIcon)`
  transform: rotate(180deg);
  height: 21px;
  width: 21px;
  margin-right: 8px;
`;

export const AppUserMenu = () => {
  const navigate = useNavigate();
  const [, , , logout] = useLogout();
  const { authorizedUserEmail } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToProfile = () => {
    handleClose();
    navigate("/profile");
  };

  return (
    <div>
      <IconButton
        size='large'
        aria-label='account of current user'
        aria-controls='menu-appbar'
        aria-haspopup='true'
        onClick={handleMenu}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id='menu-appbar'
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Typography sx={{ padding: "0 16px" }}>
          {authorizedUserEmail}
        </Typography>
        <MenuItem onClick={goToProfile}>
          <PersonOutlineIconStyled /> Profile
        </MenuItem>
        <MenuItem onClick={logout}>
          <LogoutIconStyled /> Logout
        </MenuItem>
      </Menu>
    </div>
  );
};
